/** Human-readable labels for `LoanProcessingBatchStatus` (API enum values). */
export const LOAN_PROCESSING_BATCH_STATUS_LABELS: Record<string, string> = {
  DRAFT: 'Draft',
  PENDING_L1: 'Pending Management (L1)',
  PENDING_L2: 'Pending Management (L2)',
  PENDING_OUTGOING_RECEIPT: 'Outgoing — receipt',
  PENDING_TRUSTEE: 'Outgoing — trustee send',
  COMPLETED: 'Completed',
  DENIED: 'Denied',
};
